import React from 'react'

import FormManager from "../../common/form-manager"

// @ts-ignore
import ButtonSubmit from '../../common/btn-submit/btn-submit'
import ButtonDeprecated from '../../../../../src/core/gd-components/buttons/gd-button/gd-button'

type Props = {
    className?          : string
    style?              : any

    submitLabel?        : string
    submitBtnClass?     : string
    actionsClassName?   : string
    form                : FormManager

    showSubmit?         : boolean
    cancelButton?       : boolean
    onCancelClick?      : func

    children?           : any
}

// Deprecated

export default class FormAdd extends React.Component<Props> {
    static defaultProps = {
        submitLabel: 'Submit',
        showSubmit: true,
        cancelButton: false
    }

    render() {
        const buttonCancel = this.props.cancelButton ? <ButtonDeprecated type="normal"
                                                                         label="Cancel"
                                                                         onClick={this.props.onCancelClick}
                                                                         className="btn-cancel" /> : null;

        const submitClasses = Classes('submit',this.props.submitBtnClass);
        const mainClasses = Classes("gd-form-add",this.props.className);

        return (
            <div className={mainClasses} style={this.props.style}>
                {this.props.children}
                {this.props.showSubmit &&
                <div className={Classes("actions", this.props.actionsClassName)}>
                    <ButtonSubmit form={this.props.form} label={this.props.submitLabel} className={submitClasses} /> {buttonCancel}
                </div>}
            </div>
        );
    }
}